import {ApiFilters} from '../../../core/models/interfaces/api-filters.interface';
import {ApiRuleResponseDto} from '@birco/rainmesh-api';

export const FEATURE_NAME = 'ruleState';

export interface RuleState {
  entities: Record<string, ApiRuleResponseDto>; // Cache for the actual rule objects
  error: any | null;
  isLoading: boolean;
  filter: RuleFilter;
  pages: Record<number, string[]>; // Page number to ruleIds on that page
  totalCount: number;
}

export interface RuleFilter extends ApiFilters {
  isActive?: boolean;
  isScenarioRule?: boolean;
  deviceId?: string;
}

export const initialState: RuleState = {
  entities: {},
  filter: {
    page: 0,
    pageSize: 6,
  },
  pages: {},
  totalCount: 0,
  isLoading: false,
  error: null,
};
